import React from 'react';

const About = () => (
  <section className="section about-section" id="about" aria-labelledby="about-title">
    <div className="shell section-grid">
      <div className="section-heading"><span className="section-number">01 / ABOUT</span><h2 id="about-title">Engineering AI<br />that holds up<br /><em>in practice.</em></h2><figure className="about-portrait"><img src="/profile.webp" alt="Muhammed Nihas" loading="lazy" width="240" height="300" /><figcaption>Muhammed Nihas · Bengaluru</figcaption></figure></div>
      <div className="about-content">
        <p className="lead">I design, architect, and build production AI systems using LLMs, multi-agent orchestration, retrieval-augmented generation, multimodal models, and scalable backend infrastructure.</p>
        <p>My work spans AI product development, model serving and optimization, agent evaluation, and API engineering. I focus on the decisions between a promising prototype and a system people can rely on: how it retrieves context, uses tools, handles failures, and stays observable.</p>
        <div className="focus-list" aria-label="Areas of focus">
          <div><span>01</span><strong>Agentic workflows</strong><small>State, tools, memory & guardrails</small></div>
          <div><span>02</span><strong>Retrieval systems</strong><small>Ingestion, search & reranking</small></div>
          <div><span>03</span><strong>Production delivery</strong><small>Serving, APIs & evaluation</small></div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
